var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccinationsNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vaccinations_new_entry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "transparent_backgrounds",
    "data-name": "transparent backgrounds"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.62,
    y: 0.07,
    width: 600,
    height: 600,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "vaccinations_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.15,
    cy: 299.73,
    r: 297.95,
    fill: "#00b2db"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.46,244.66H356.81V160.07a55.81,55.81,0,0,0-55.65-55.65h0a55.81,55.81,0,0,0-55.64,55.65v84.59H165.89a55.81,55.81,0,0,0-55.64,55.64h0A55.81,55.81,0,0,0,165.89,356h79.63v84.68a55.81,55.81,0,0,0,55.64,55.65h0a55.81,55.81,0,0,0,55.65-55.65V356h89.65a55.81,55.81,0,0,0,55.65-55.65h0A55.81,55.81,0,0,0,446.46,244.66Z",
    fill: "#d4fffe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccinationsNewEntry);
export default __webpack_public_path__ + "static/media/vaccinations_new_entry.b669bf71eea209a082ebfb51b6b388ba.svg";
export { ForwardRef as ReactComponent };